function WhyNoPickupInMyArea() {
  return (
    <>

      <p>

        <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          At the moment, we have pick up services in Greater Toronto Area,
          Brampton and Edmonton. You can still order items to your home or P.O.
          box for free over $99. We will be launching a similar pick up service
          in select cities across Canada in the near future. Stay tuned!
        </span>
      </p>

      <p>

        <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          We will also be offering
          {" "}

          <b>Free</b>
          {" "}
          drop-off &amp; returns services
          for the selected cities.
        </span>
      </p>
    </>
  );
}

export default WhyNoPickupInMyArea;
